// Parses a CSV or XLSX file (from the parent's own device — nothing is
// uploaded anywhere for parsing) into an array of plain string-keyed row
// objects, using the first row as headers. Works for both formats since
// SheetJS treats CSV as a single-sheet workbook. Ported from school-site's
// src/lib/csv.ts.
//
// SheetJS is a sizable dependency only this Import tab needs — dynamically
// imported here so the student's every-day pages (Today, This week) never
// pay for it in their bundle.
export async function parseSpreadsheet(file) {
  const XLSX = await import('xlsx');
  const buf = await file.arrayBuffer();
  const workbook = XLSX.read(buf, { type: 'array' });
  const sheet = workbook.Sheets[workbook.SheetNames[0]];
  const rows = XLSX.utils.sheet_to_json(sheet, { defval: '' });
  return rows.map(row => {
    const out = {};
    for (const [k, v] of Object.entries(row)) out[k.trim().toLowerCase()] = String(v).trim();
    return out;
  });
}

export function slugify(s) {
  return (
    s
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '') || 'item'
  );
}
